import virtualYearbookImg from "../images/item/item-01.png";
const vimeoVideoUrls = {
    interactiveVirtualTour: "https://player.vimeo.com/video/929219923?badge=0&autopause=0&player_id=0&app_id=58479&title=0&byline=0&portrait=0",    
};
const dataItem = [
 
];

export default dataItem;
